import React from "react";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { RefreshCw, X } from "lucide-react";

export function NpsAvailablePicker({ items, minScore, onMinScoreChange, onReload, onPick, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-sm shadow-xl w-full sm:max-w-2xl max-h-[85vh] flex flex-col"
        data-testid="nps-picker"
      >
        <div className="px-5 py-4 border-b border-gray-200 flex items-center justify-between gap-3">
          <div>
            <h3 className="font-serif text-lg text-gray-900">Seleccionar respuesta NPS</h3>
            <p className="text-xs text-gray-600">
              Promotores con comentario y no seleccionados aún.
            </p>
          </div>
          <button onClick={onClose} className="p-1.5 text-gray-500 hover:text-gray-900">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="px-5 py-3 border-b border-gray-200 flex items-center gap-3 text-sm">
          <label className="text-gray-700">Score mínimo</label>
          <input
            type="number"
            min={0} max={10}
            value={minScore}
            onChange={(e) => onMinScoreChange(parseInt(e.target.value, 10) || 0)}
            className="input-base w-20"
            data-testid="min-score-input"
          />
          <Button size="sm" variant="outline" onClick={onReload} className="rounded-sm border-gray-300" data-testid="btn-reload-available">
            <RefreshCw className="h-3.5 w-3.5 mr-1" /> Recargar
          </Button>
          <span className="ml-auto text-xs text-gray-500">{items.length} disponibles</span>
        </div>
        <ul className="flex-1 overflow-y-auto divide-y divide-gray-100">
          {items.length === 0 ? (
            <li className="px-5 py-10 text-center text-sm text-gray-500">
              Sin respuestas NPS disponibles con score ≥ {minScore} y comentario.
            </li>
          ) : (
            items.map((n) => {
              const id = n.nps_response_id || n.id;
              return (
                <li key={id} className="px-5 py-3 hover:bg-gray-50" data-testid={`nps-available-${id}`}>
                  <div className="flex items-start gap-3">
                    <Badge className="rounded-sm bg-emerald-50 text-emerald-800 border border-emerald-300 shrink-0">
                      {n.score}
                    </Badge>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm text-gray-900 truncate">{n.user_email || "Usuario"}</div>
                      <div className="text-xs text-gray-600 mb-1">
                        {n.nivel === "nivel1" ? "Diagnóstico" : "Kit Documental"}{" "}
                        {n.created_at && `· ${new Date(n.created_at).toLocaleDateString()}`}
                      </div>
                      <p className="text-xs text-gray-700 italic">&ldquo;{n.comment}&rdquo;</p>
                    </div>
                    <Button size="sm" onClick={() => onPick(n)} className="rounded-sm bg-primary shrink-0" data-testid={`btn-pick-${id}`}>
                      Agregar
                    </Button>
                  </div>
                </li>
              );
            })
          )}
        </ul>
      </div>
    </div>
  );
}
